(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
  jQuery(document).ready(function ($){
  $('.carousel').carousel({
   interval: 2000,
    ride: 'carousel'
 });
   })
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });


 // const closeButton = document.querySelectorAll(".btn-close");
 //  if(closeButton){
 //    closeButton.forEach((item)=>{
 //      item.addEventListener("click",function(){
 //        item.parentElement.slideUp()
 //      })
 //    })
 //  }

  } catch(e) { console.error(e); }
})();
})();
